import { api } from "../api/api";
import { properties } from '../constants/Propertise';

const UPDATE_PROFILE_PENDING = 'UPDATE_PROFILE_PENDING';
const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
const UPDATE_PROFILE_ERROR = 'UPDATE_PROFILE_ERROR';

export function updateUserProfile(formData) {
  return dispatch => {
    dispatch(updateProfilePending(true));
    let updateProfileUrl = "user/updateUser/"+formData['id'];
    api
      .put(updateProfileUrl, formData)
      .then(updateResult => {
        dispatch(updateProfileSuccess(updateResult.data, true));
      })
      .catch(err => {
        dispatch(updateProfileError(properties.globalErrorMessage));
      });
  }
}

function updateProfilePending(updateProfilePending) {
  return {
    type: UPDATE_PROFILE_PENDING,
    updateProfilePending: updateProfilePending,
    updateProfileSuccess: false,
    updateProfileError: false,
    apiError : false
  };
}

function updateProfileSuccess(profileData, updateProfileSuccess) {
  return {
    type: UPDATE_PROFILE_SUCCESS,
    updateProfilePending: false,
    updateProfileSuccess: updateProfileSuccess,
    updateProfileError: false,
    updateProfileData: profileData,
    apiError : false
  };
}

function updateProfileError(apiError) {
  return {
    type: UPDATE_PROFILE_ERROR,
    updateProfileError : true,
    updateProfileSuccess: false,
    updateProfilePending: false,
    apiError : true
  }
}

export default function UserProfileReducer(state = {
  updateProfileError: false,
  updateProfileSuccess: false,
  updateProfilePending: false,
  show: false,
  apiError : false,
  updateProfileData: {}
}, action) {
  switch (action.type) {
    case UPDATE_PROFILE_PENDING:
      return Object.assign({}, state, {
        updateProfilePending: action.updateProfilePending,
        updateProfileSuccess: action.updateProfileSuccess,
        updateProfileError: action.updateProfileError,
        apiError : action.apiError,
        updateProfileData : []
      });

    case UPDATE_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        updateProfilePending: action.updateProfilePending,
        updateProfileSuccess: action.updateProfileSuccess,
        updateProfileError: action.updateProfileError,
        apiError : action.apiError,
        updateProfileData: action.updateProfileData
      });

    case UPDATE_PROFILE_ERROR:
      return Object.assign({}, state, {
        updateProfilePending: action.updateProfilePending,
        updateProfileSuccess: action.updateProfileSuccess,
        updateProfileError: action.updateProfileError,
        apiError : action.apiError,
        updateProfileData : []
      });

    default:
      return state;
  }
}